import { Card } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useEffect } from 'react';
import { GraficoBar } from './GraficoBar';
import { useInternacionesTramitesPorDelegacionBarra } from '../hooks';
dayjs.locale('es'); // activa el idioma español

export const IniciadoAnualBarra = ({ date, data }) => {
  const { datosIniciadasAnualesBarras, getDatosIniciadasAnualesBarras } =
    useInternacionesTramitesPorDelegacionBarra({
      anualList: data,
      top: 20,
    });

  useEffect(() => {
    if (data && data.length > 0) {
      getDatosIniciadasAnualesBarras();
    }
  }, [data]);

  return (
    <>
      <Card
        sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: { xs: '500px', sm: '100%' } }}
      >
        <GraficoBar
          labels={datosIniciadasAnualesBarras?.labels}
          datasets={datosIniciadasAnualesBarras?.datasets}
          options={{
            plugins: {
              title: {
                text: 'Top 20 - Autorizaciones pendientes del ' + dayjs(date).format('YYYY'),
                display: true,
              },
              legend: { position: 'bottom' },
            },
          }}
        />
      </Card>
    </>
  );
};
